export const searchProperties = {
  statusKey:         'status',
  statusSucceeded: 'SUCCEEDED',
  statusSuccess: 'SUCCESS',
  statusFailed: 'FAILED',
};
